module.exports = __webpack_public_path__ + "img/commonly.42b068f4.png";